<ul class="additionBrand">
<li>
  <label>
    Brand {{i+1}}
  </label>
    <div class="dataField">
      <input type="text" #brandInput class="textBox" [readonly]="!storyEditMode" placeholder="Add Brand here."
        [(ngModel)]="brandQuery" (keyup)="filterAutoCompleteUp($event ,'brand')" (keydown)="filterAutoCompleteDown($event ,'brand')"
        (focus)="focusInSuggest('brand', i)" (focusout)="false">
      <ng-container *ngIf="storyEditMode && insideAddedBrand === true">
        <ng-container *ngIf="currentSelectedBrand === i">
          <div #brandList class="autosuggestion block" *ngIf="filteredNewBrandSuggestion && filteredNewBrandSuggestion.length > 0 ">
            <ul *ngFor="let item of filteredNewBrandSuggestion;let i = index">
              <li (click)="selectAutoComplete('brand', item)" [class.active]="i === currentSelection">
                <span class="name">{{item}}</span>
                <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
              </li>
            </ul>
          </div>
        
        <ng-container *ngIf="insideAddedBrand && (1 > filteredNewBrandSuggestion.length)">
          <div class="autosuggestion block">
            <ul>
              <li>
                <span class="name">No Results</span>
              </li>
            </ul>
          </div>
        </ng-container>
      </ng-container>
      </ng-container>
    </div>
</li>
<ng-container *ngIf="addedBrand['brand'] !== ''">
<li>
  <label>
    Model {{i+1}}
  </label>
    <div class="dataField">
      <input type="text" class="textBox" #modelInput  [readonly]="!storyEditMode" placeholder="Add Model here."
        [(ngModel)]="modelQuery" (keyup)="filterAutoCompleteUp($event ,'model')" (keydown)="filterAutoCompleteDown($event ,'model')"
        (focus)="focusInSuggest('model', i)" (focusout)="false">
        <ng-container *ngIf="storyEditMode && insideAddedModel === true">
          <ng-container *ngIf="currentSelectedBrand === i">
            <div #modelList class="autosuggestion block" *ngIf="filteredNewModelSuggestion && filteredNewModelSuggestion.length > 0 ">
                <ul *ngFor="let item of filteredNewModelSuggestion;let i = index">
                  <li (click)="selectAutoComplete('model', item)" [class.active]="i === currentSelection">
                    <span class="name">{{item}}</span>
                    <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                  </li>
                </ul>
              </div>
          </ng-container>
        </ng-container>
        
        <ng-container *ngIf="insideAddedModel && (!filteredNewModelSuggestion || 1 > filteredNewModelSuggestion.length)">
          <div class="autosuggestion block">
            <ul>
              <li>
                <span class="name">No Results</span>
              </li>
            </ul>
          </div>
        </ng-container>
    </div>
</li>
</ng-container>
</ul>


